import React from 'react';
import { Header as UikitHeader, Logo, Text } from '@libs/uikit/Components';

export const Header = () => {
    const refreshPage = () => window.location.replace(window.location.origin + window.location.pathname);

    return (
        <UikitHeader style={{position: 'fixed', top: 0, width: '100%', zIndex: 1001}}>
            <div onClick={refreshPage}>
                <Logo onClick={refreshPage} />
            </div>
            <sup>
                <Text inline>| Vpaid Tester</Text>
            </sup>
        </UikitHeader>
    );
};
